<template>
    <div class="wa-blast-template-list">
        <div class="m-d-16" v-for="data in dataList" :key="data.id">
            <SOSlotCard
                :id="`card-${data.id}`"
                :card-type="'box'"
                @loadMore="doLoadMore"
                @toogleCard="toggleCard"
                :last-id="getLastId"
            >
                <template v-slot:card_body>
                    <!--<div class="card-template-blast" :id="`card-template-${id}`">-->
                    <div class="p-t-8 p-d-12">
                        <div class="custom-control custom-checkbox remove-padding" @click="checkboxClicked(data.id)">
                            <input type="checkbox" :id="`template-${data.id}`" name="template"
                                   class="custom-control-input"
                                   :value="`${data.id}`"
                                   v-model="selectedIdtemplate"
                            >
                            <label :for="`template-${data.id}`" class="custom-control-label label-checklist f-16"
                                   v-if="search === ''">
                                {{ data.nama }}
                            </label>
                            <label :for="`template-${data.id}`" class="custom-control-label label-checklist f-16 f-c-black"
                                   v-else
                                   v-html="searchHighlight(data.nama, search)"
                            >
                            </label>
                        </div>
                    </div>

                    <div class="p-d-8">
                        <div class="card-template-blast-text d-flex-between-center" @click="preview(data.id)">
                            <div class="template-ellipsis f-regular f-14 f-c-midgrey"
                                 v-html="data.template.replace(/]/g, '</span>').replace(/\[/g, `<span class='badge color-red' style='border-radius: 4px !important; padding: 1px 4px !important;'>`)"
                            >
                            </div>
                            <div class="align-self-end">
                                <img src="@/assets/icon-sidebar/chevron-down.svg" alt="">
                            </div>
                        </div>
                    </div>
                    <!--</div>-->
                </template>
            </SOSlotCard>
        </div>
    </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import {moduleName} from "./../store/state";
import SOSlotCard from "@/so-components/global/slot/SOSlotCard";

export default {
    name: "CardTemplateBlast",
    components: {
        SOSlotCard,
    },
    props: {
        dataList: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            selectedIdtemplate: [],
        }
    },
    watch: {
        selectedIdtemplate: {
            handler: function () {
                this.$emit("selectedIdTemplate", this.selectedIdtemplate)
            },
        }
    },
    computed: {
        ...mapGetters(moduleName, {
            isFetching: "isFetching",
            isLoadMore: "isLoadMore",
            paginationTemplate: "paginationTemplate",
            endItemofPage: "endItemofPage",
            totalTemplate: "totalTemplate",

            payload: "payloadCreateBlast",
            search: "search",
        }),
        getLastId() {
            return this.endItemofPage.id ? `card-${this.endItemofPage.id}` : "";
        },
    },
    mounted() {
        setTimeout(() => {
            this.selectedIdtemplate = this.payload.idtemplate
            this.payload.idtemplate.forEach(v => {
                $("#card-" + v).children().css({"background": "#EDF5FF", "border": "1px solid #206CFF"})
            })
        }, 200)
    },
    methods: {
        ...mapActions({
            fetchListTemplate: `${moduleName}/fetchListTemplate`,
            setLoadMore: `${moduleName}/setLoadMore`,
            toggleDisplayItem: `${moduleName}/toggleDisplayItem`,
        }),
        async doLoadMore() {
            if (this.totalTemplate > this.paginationTemplate.length) {
                if (!this.isFetching) {
                    await this.setLoadMore(true);
                    await this.fetchListTemplate();
                }
            }
        },
        toggleCard(data) {
            this.toggleDisplayItem(data);
        },

        checkboxClicked(id) {
            if ($("#template-" + id).is(":checked")) {
                $("#card-" + id).children().css({"background": "#EDF5FF", "border": "1px solid #206CFF"})
            } else {
                $("#card-" + id).children().css({"background": "#FFFFFF", "border": "1px solid #c8d0dd"})
            }
        },
        preview(id) {
            this.$router.push({
                name: "wa_blast.template.preview",
                params: {
                    id: id.toString(),
                    title: "Preview",
                    mode: 2,
                }
            })
        }
    }
}
</script>

<style scoped>
.card-template-blast-text {
    padding: 4px 10px;

    background: #FAFAFA;
    box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.15);
    border-radius: 8px;
}

.template-ellipsis {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
}
</style>